import React, { Component } from 'react';
import { withResponsiveFlags } from '~/hoc/withResponsiveProps';
import { HStack } from "~/native-ui";
import { ActionMenu } from "~/ui/ActionMenu/ActionMenu";



class ItemActions extends Component {
	static propTypes = {
	
	};

    // renderSaveButton() {
    //     let { isDirty, itemId, trans, subviewCount, saveButtonProps } = this.props;

    //     let disableSave = !saveButtonProps?.enabled && (!isDirty && itemId !== identify.NEW_ITEM),
    //         onlyContinue = subviewCount &&  itemId === identify.NEW_ITEM,
    //         labelKey = saveButtonProps?.label || (onlyContinue ? 'continue' : 'save'),
    //         icon,
    //         iconFamily = saveButtonProps?.icon ? saveButtonProps?.iconFamily : undefined;

    //     icon = onlyContinue ? "forward" : icon;
    //     icon = saveButtonProps?.icon || icon;

    //     return (
    //         <SaveButton
    //             key="save"
    //             disabled={disableSave}
    //             onPress={this.props.saveItem}
    //             label={trans(labelKey)}
    //             icon={icon}
    //             iconFamily={iconFamily}
    //         />
    //     );
    // }

    // renderEditButton = () => {
    //     let { trans, itemId, actionPermissions } = this.props;

    //     let canEdit = itemId === identify.NEW_ITEM && actionPermissions.create || itemId !== identify.NEW_ITEM && actionPermissions.update;

    //     return (
    //         <SaveButton
    //             primary
    //             key="create"
    //             icon="create"
    //             iconSize="sm"
    //             onPress={this.props.editEntry}
    //             disabled={!canEdit}
    //             label={trans('edit')}
    //         />
    //     );
    // };

    // renderMainActionButtons() {
    //     let { isDirty, view } = this.props;

    //     let buttons = [];

    //     if(view === identify.VIEW_VIEW) {
    //         buttons.push(this.renderEditButton());
    //     }

    //     if(view === identify.VIEW_EDIT) {
    //         buttons.push(this.renderSaveButton());
    //     }

    //     const hasVisibleAction = Object.values(this.props.actions).flat().length;
    //     if (buttons.length && hasVisibleAction && this.props.itemId !== identify.NEW_ITEM) {
    //         buttons.unshift(<Divider key="divider" orientation="vertical" bg="coolGray.300" h="5" mx="2" />);
    //     }

    //     return buttons;
    // }

    contentContainerStyle = {alignItems: "center", justifyContent: "flex-end", flexGrow: 0, flexShrink: 0 }
	render() {
        let { isDirty } = this.props;

        return (
                <HStack {...this.contentContainerStyle}>
                    <ActionMenu {...this.props} disabled={isDirty} dropdownMode={this.props.isSmallScreen} />

                    {/* {this.renderMainActionButtons()} */}
                </HStack>
        );
	}
}

export default withResponsiveFlags(ItemActions, { includeKeys: ['isSmallScreen']})